// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CoreXNav-cls1__c4262db724787193263f{/*!*/}.CoreXNav-cls2__c6998ef559b4394c5131{display:flex;align-items:center;grid-gap:8px;gap:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "CoreXNav-cls1__c4262db724787193263f",
	"cls2": "CoreXNav-cls2__c6998ef559b4394c5131 CoreXNav-cls1__c4262db724787193263f"
};
export default ___CSS_LOADER_EXPORT___;
